import { registerFeatureNotificationStrategies } from './registerNotificationStrategies';

let initialized = false;

export function initializeNotificationWorkflow() {
  if (initialized) {
    return;
  }

  registerFeatureNotificationStrategies();
  initialized = true;
}

export { NOTIFICATION_TYPES, type NotificationType } from './types';
